import './FilterToggle.scss';

export interface FilterOption<T extends string = string> {
  key: T;
  label: string;
  count?: number;
}

interface FilterToggleProps<T extends string> {
  options: FilterOption<T>[];
  activeFilter: T;
  onChange: (filter: T) => void;
}

export function FilterToggle<T extends string>({ 
  options, 
  activeFilter, 
  onChange 
}: FilterToggleProps<T>) {
  return (
    <div className="filter-toggle">
      {options.map((option) => {
        const isActive = activeFilter === option.key;
        return (
          <button
            key={option.key}
            onClick={() => onChange(option.key)}
            className={`filter-toggle__button ${isActive ? 'active' : ''}`}
          >
            {option.label}
            {option.count !== undefined && option.count > 0 && (
              <span className="filter-toggle__count">
                {option.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
